import { PickemLeaderboardTable } from '../PickemLeaderboardTable';
import { useGetPickemLeaderboard } from '@/api/pickem-leaderboard/getPickemLeaderboard.ts';
import { PickemControlBar } from '@/pages/LeaderboardPage/PickemControlBar/index.tsx';
import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';

export const PickemLeaderboardSection = () => {
  const { pickemId } = useAppSearchParams();
  const { data: pickemLeaderboardData } = useGetPickemLeaderboard({
    pickemId,
    offset: 0,
    limit: 50,
  });

  return (
    <>
      {pickemLeaderboardData && (
        <PickemControlBar leaderboardData={pickemLeaderboardData} />
      )}

      {/* Pined User ID's (temporally hidden) */}
      {/*<Card sx={{ padding: 4, marginBottom: 4 }}>*/}
      {/*  <Grid container spacing={2}>*/}
      {/*    <form.Field*/}
      {/*      name='pin_user_id'*/}
      {/*      children={({ state, handleChange }: AnyFieldApi) =>*/}
      {/*        (typeof state.value === 'string'*/}
      {/*          ? ['', '', '']*/}
      {/*          : state.value*/}
      {/*        ).map((value: number[], index: number) => (*/}
      {/*          <Grid item xs={4}>*/}
      {/*            <TextField*/}
      {/*              label={`Leaderboard Pin User ID ${index + 1}`}*/}
      {/*              fullWidth*/}
      {/*              value={value[index] ?? ''}*/}
      {/*              variant='standard'*/}
      {/*              onChange={(e) => {*/}
      {/*                const newValue = [...state.value];*/}
      {/*                newValue[index] = parseInt(e.target.value) || 0;*/}
      {/*                handleChange(newValue);*/}
      {/*              }}*/}
      {/*            />*/}
      {/*          </Grid>*/}
      {/*        ))*/}
      {/*      }*/}
      {/*    />*/}
      {/*  </Grid>*/}
      {/*</Card>*/}

      <PickemLeaderboardTable />
    </>
  );
};
